import { render, staticRenderFns } from "./PrintInCode38050.vue?vue&type=template&id=480ee22b&scoped=true"
import script from "./PrintInCode38050.vue?vue&type=script&lang=js"
export * from "./PrintInCode38050.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ee22b",
  null
  
)

export default component.exports